/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_rectangle from "../../assets/images/pictures/icon/ic_retangle_blue.svg";
import { useTranslation } from "react-i18next";
import hovi from "../../assets/images/logos/customer/hovi.png";
import dash from "../../assets/images/logos/customer/dash.png";
import bite from "../../assets/images/logos/customer/bite.png";
import bankas from "../../assets/images/logos/customer/bankas.png";
import perlat from "../../assets/images/logos/customer/perlat.png";
import scan from "../../assets/images/logos/customer/scan.png";
import invenga from "../../assets/images/logos/customer/invenga.png";
import vaiku from "../../assets/images/logos/customer/vaiku.png";
const CustomerStoriesCompanies = (props) => {
  const { t } = useTranslation();
  return (
    <div className="container customers mt-40 mb-50 px-md-0">
      <div className="row">
        <div className="col-sm-12 text-center pb-20">
          <img
            width="35"
            height="6"
            src={ic_rectangle}
            className="attachment-full size-full"
            alt=""
            decoding="async"
            loading="lazy"
            data-no-retina=""
          />
          <h1>{t("customer.note5")}</h1>
        </div>
        {props.currentPage === "hoovi" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/hoovi" className="card">
              <img
                src={hovi}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note6")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "danish" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a
              href="/customer-stories/danish-technological-institute"
              className="card"
            >
              <img
                src={dash}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note7")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "bite" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/bite-it" className="card">
              <img
                width="85"
                height="85"
                src={bite}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note8")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "financing" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/general-financing-bank" className="card">
              <img
                src={bankas}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note9")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "loto" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/loto-it" className="card">
              <img
                src={perlat}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note10")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "scandagra" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/scandagra" className="card">
              <img
                src={scan}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note11")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "invega" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/invega" className="card">
              <img
                src={invenga}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note12")}</p>
              </div>
            </a>
          </div>
        )}
        {props.currentPage === "vaiku" ? (
          <></>
        ) : (
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="/customer-stories/vaiku-linija" className="card">
              <img
                src={vaiku}
                className="card__logo"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <div className="card__info">
                <p>{t("customer.note13")}</p>
              </div>
            </a>
          </div>
        )}
        {/* <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="85" height="95" src="https://www.dokobit.com/wp-content/uploads/2022/10/lsmu-small7.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info"><p>With GoPaperless, you don’t need to travel anywhere, and signing takes just a few minutes</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="135" height="56" src="https://www.dokobit.com/wp-content/uploads/2022/09/connectpay-small-2.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info"><p>The total signature collection period shrank from 30 weeks to 45 days per year</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="110" height="50" src="https://www.dokobit.com/wp-content/uploads/2022/09/ESTO-small2.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>Customers can now sign loan agreements in just a few clicks</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="129" height="58" src="https://www.dokobit.com/wp-content/uploads/2022/09/enefit-lg-small.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>Ease of use and simplicity – among the main advantages</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="144" height="23" src="https://www.dokobit.com/wp-content/uploads/2022/08/mx-logo-small-2.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>The process of signing and storing contracts has become noticeably faster</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="120" height="49" src="https://www.dokobit.com/wp-content/uploads/2022/07/fjord-logo-small.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>The cost of programming and IT maintenance reduced significantly</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="139" height="33" src="https://www.dokobit.com/wp-content/uploads/2022/04/MB-logo.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>The signature collection process has accelerated the work between various divisions around the country</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="139" height="48" src="https://www.dokobit.com/wp-content/uploads/2022/03/rimi.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>By switching to e-signing, almost 60 000 pages of paper were saved</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="151" height="38" src="https://www.dokobit.com/wp-content/uploads/2021/09/sb-lizingas-small.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>The encouragement for digitisation — paper conversion to terabytes</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="180" height="52" src="https://www.dokobit.com/wp-content/uploads/2021/08/cspage-compensa.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p>Over 60% of new life insurance contracts are signed using e-signatures</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="114" height="32" src="https://www.dokobit.com/wp-content/uploads/2021/05/wilogo.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info">
                                    <p className="entry-title">Possibility to e-sign employment agreements increased the number of potential employees</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="124" height="50" src="https://www.dokobit.com/wp-content/uploads/2021/05/rvlogo.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info"><p className="entry-title">After getting rid of paper, sales increased by 20%</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <a href="javascript:;" className="card">
                                <img width="94" height="36" src="https://www.dokobit.com/wp-content/uploads/2020/10/telia-logo.png?v2" className="card__logo" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <div className="card__info"><p>Contract signing with customers shortened from days to hours</p>
                                </div>
                            </a>
                        </div> */}
      </div>
    </div>
  );
};

export default CustomerStoriesCompanies;
